<script setup lang="ts">
withDefaults(defineProps<{
  show: boolean
}>(), {
  show: false,
})

const emit = defineEmits<{
  (e: 'close'): void
}>()

const { t } = useI18n()

const cards = [
  {
    title: t('formalization.electricity_bills.modal_what_is_bond.cards.first.title'),
    textStart: t('formalization.electricity_bills.modal_what_is_bond.cards.first.text_start'),
    emphasis: t('formalization.electricity_bills.modal_what_is_bond.cards.first.emphasis'),
    textEnd: t('formalization.electricity_bills.modal_what_is_bond.cards.first.text_end'),
  },
  {
    title: t('formalization.electricity_bills.modal_what_is_bond.cards.second.title'),
    textStart: t('formalization.electricity_bills.modal_what_is_bond.cards.second.text_start'),
    emphasis: t('formalization.electricity_bills.modal_what_is_bond.cards.second.emphasis'),
    textEnd: t('formalization.electricity_bills.modal_what_is_bond.cards.second.text_end'),
  },
]
</script>

<template>
  <div>
    <SolModal
      id="modal-preview-file"
      :is-open="show"
      :title="t('formalization.electricity_bills.what_is_proof_of_link')"
      :size="{ desktop: 'medium', mobile: 'full' }"
      class="overflow-auto"
      :action-primary-text="t('formalization.electricity_bills.modal_what_is_bond.okay')"
      @close="emit('close')"
      @action:primary="emit('close')"
    >
      <div class="flex flex-col items-start gap-6">
        <span class="fonts-body-large-regular text-brand-primary-dark">
          {{ t('formalization.electricity_bills.modal_what_is_bond.description.part_1') }}
          <span class="fonts-body-large-bold">
            {{ t('formalization.electricity_bills.modal_what_is_bond.description.bond_degree') }}
          </span>
          {{ t('formalization.electricity_bills.modal_what_is_bond.description.part_2') }}
          <span class="fonts-body-large-bold">
            {{ t('formalization.electricity_bills.modal_what_is_bond.description.holder') }}
          </span>
          {{ t('formalization.electricity_bills.modal_what_is_bond.description.part_3') }}
          <span class="fonts-body-large-bold">
            {{ t('formalization.electricity_bills.modal_what_is_bond.description.borrower') }}</span>.
        </span>

        <div class="flex flex-col items-stretch gap-4 w-full">
          <div
            v-for="(card, index) in cards"
            :key="index"
            class="
              flex flex-col items-start gap-1 w-full p-4
              bg-brand-secondary-light rounded-lg bg-opacity-intense
            "
          >
            <p class="fonts-body-medium-bold text-brand-primary-dark">
              {{ card.title }}
            </p>
            <p class="fonts-body-medium-regular text-brand-primary-dark">
              {{ card.textStart }}
              <span class="italic">{{ card.emphasis }}</span>{{ card.textEnd }}
            </p>
          </div>
        </div>
      </div>
    </SolModal>
  </div>
</template>

<style scoped>

</style>
